<template>
    <div class="logisticsMonitoring">
        <van-nav-bar
            title="物流监控"
            left-text="应用"
            left-arrow
            @click-left="onClickLeft"
        >
            <template #right>
                <van-dropdown-menu>
                    <van-dropdown-item
                        v-model="currentStationId"
                        :options="stationList"
                        @change="changeStation"
                    ></van-dropdown-item>
                </van-dropdown-menu>
            </template>
        </van-nav-bar>
        <section>
            <div class="_map map-con">
                <baidu-map
                    :center="mapCenter"
                    :zoom="zoom"
                    class="baidumap"
                    @ready="handleReady"
                >
                    <bm-local-search
                        :keyword="searchPos"
                        location="全国"
                        :searchcomplete="onSearchResult"
                        :auto-viewport="true"
                        class="local-search"
                    ></bm-local-search>
                    <!-- 车辆点标记 -->
                    <bm-marker
                        v-for="(marker, index) in markers"
                        :key="index"
                        :position="marker.position"
                        :icon="{url: marker.icon, size: marker.size}"
                        :rotation="marker.rotation"
                        @click="switchWindow(index, marker, marker.position)"
                    >
                        <bm-label
                            :content="marker.plate_small_number"
                            :offset="marker.offset"
                        ></bm-label>
                    </bm-marker>
                    <!-- 工程地址 -->
                    <bm-marker
                        v-for="(marker, index) in projectsAddressMarkers"
                        :key="`address${index}`"
                        :position="marker.position"
                        :icon="{url: marker.icon, size: marker.size}"
                    >
                        <bm-label
                            :content="marker.project_name"
                            :offset="marker.offset"
                        ></bm-label>
                    </bm-marker>
                    <!-- 信息窗体 -->
                    <bm-info-window
                        :position="windows.position"
                        :show="windows.visible"
                        :offset="windows.offset"
                        :close-on-click="true"
                        class="car-info-window"
                    >
                        <div class="car-info" v-if="carInfo">
                            <div class="icon iconfont iconjiantouxia"></div>
                            <div class="info-header">
                                <div>
                                    <span class="iconfont">&#xe6a3;</span>
                                    <span class="plateNumber">{{ carInfo.plate_number }}</span>
                                    <span class="trumpet">{{ carInfo.plate_small_number }}</span>
                                    <span
                                        v-if="[6, 7, 73].indexOf(carInfo.status) > -1"
                                        class="transportation-status transportation-status-green"
                                    >运输中</span>
                                    <span
                                        v-else-if="[77, 8].indexOf(carInfo.status) > -1"
                                        class="transportation-status transportation-status-yellow"
                                    >返场中</span>
                                    <span v-else class="transportation-status transportation-status-red">未运输</span>
                                </div>
                            </div>
                            <div class="info-detailed">
                                <template v-if="[6, 7, 73, 77, 8].indexOf(carInfo.status) > -1">
                                    <div>
                                        <p>
                                            <span class="iconfont iconkehu"></span>
                                            <span>司机姓名：{{ carInfo.driver_name }}</span>
                                        </p>
                                        <p style="text-align: right;">
                                            <span class="iconfont icondianhua"></span>
                                            <span>电话：{{ carInfo.driver_phone }}</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconbianhao"></span>
                                            <span>发货单号：{{ carInfo.pcb_number }}</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconshigonggongdi"></span>
                                            <span>工地名称：{{ carInfo.project_name }}</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconcishu"></span>
                                            <span>今日运输次数：{{ carInfo.cur_count }}</span>
                                        </p>
                                    </div>
                                    <template v-if="[77, 8].indexOf(carInfo.status) > -1">
                                        <div>
                                            <p>
                                                <span class="iconfont iconlicheng"></span>
                                                <span>车辆距场站（KM）：{{ carInfo.to_station_distance }}</span>
                                            </p>
                                        </div>
                                        <div>
                                            <p>
                                                <span class="iconfont iconshijian"></span>
                                                <span>预计到达场站时间：{{ SecondToDate(carInfo.to_station_time) }}</span>
                                            </p>
                                        </div>
                                    </template>
                                    <template v-else>
                                        <div>
                                            <p>
                                                <span class="iconfont iconlicheng"></span>
                                                <span>车辆距工地（KM）：{{ carInfo.to_project_distance }}</span>
                                            </p>
                                        </div>
                                        <div v-if="carInfo.status == 6">
                                            <p>
                                                <span class="iconfont iconshijian"></span>
                                                <span>预计到达工地时间：{{ SecondToDate(carInfo.to_project_time) }}</span>
                                            </p>
                                        </div>
                                        <div v-else>
                                            <p>
                                                <span class="iconfont iconshijian"></span>
                                                <span>到达工地时间：{{ SecondToDate(carInfo.arrival_time) }}</span>
                                            </p>
                                        </div>
                                    </template>
                                </template>
                                <template v-else>
                                    <div>
                                        <p>
                                            <span class="iconfont iconkehu"></span>
                                            <span>司机姓名：{{ carInfo.driver_name }}</span>
                                        </p>
                                        <p style="text-align: right;">
                                            <span class="iconfont icondianhua"></span>
                                            <span>电话：{{ carInfo.driver_phone }}</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconbianhao"></span>
                                            <span>发货单号：</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconshigonggongdi"></span>
                                            <span>工地名称：</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconcishu"></span>
                                            <span>今日运输次数：{{ carInfo.cur_count }}</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconlicheng"></span>
                                            <span>车辆距工地（KM）：</span>
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            <span class="iconfont iconshijian"></span>
                                            <span>到达工地时间：</span>
                                        </p>
                                    </div>
                                </template>
                            </div>
                        </div>
                    </bm-info-window>
                    <!-- 工地圆圈 -->
                    <bm-circle
                        :key="`projectCircle_${index}`"
                        v-for="(circle, index) in projectCircles"
                        :center="circle.center"
                        :radius="circle.radius"
                        :stroke-color="circle.strokeColor"
                        :stroke-opacity="circle.strokeOpacity"
                        :stroke-weight="circle.strokeWeight"
                        :fill-color="circle.fillColor"
                        :fill-opacity="circle.fillOpacity"
                        :stroke-style="circle.strokeStyle"
                    ></bm-circle>
                    <!-- 场站圆圈 -->
                    <bm-circle
                        :key="`stationCircle_${index}`"
                        v-for="(circle, index) in stationCircles"
                        :center="circle.center"
                        :radius="circle.radius"
                        :stroke-color="circle.strokeColor"
                        :stroke-opacity="circle.strokeOpacity"
                        :stroke-weight="circle.strokeWeight"
                        :fill-color="circle.fillColor"
                        :fill-opacity="circle.fillOpacity"
                        :stroke-style="circle.strokeStyle"
                    ></bm-circle>
                </baidu-map>
            </div>
        </section>
        <actionsPanel
            :projects-statistics="projectsStatistics"
            :car-statistics="carStatistics"
            :station-id="currentStationId"
            @projectsClick="handleProjectsClick"
            @carClick="handleCarClick"
            @closeInfoWindow="closeInfoWindow"
            @searchPos="searchPosFn"
        ></actionsPanel>
    </div>
</template>

<script>
import Vue from 'vue';
import BaiduMap from 'vue-baidu-map-v3';
Vue.use(BaiduMap, {
    ak: '8oGi1YBeLNnGA54yA1YuyumkzjjfGqmW',
});
import { eventBus } from '@/common/eventBus.ts';
import util from '@/utils/util';
import actionsPanel from './actionsPanel';
export default {
    name: 'map-page',
    components: {
        actionsPanel,
    },
    data() {
        return {
            searchPos: '',
            iconStatus: true,
            searchInfo: '',
            zoom: 13,
            mapCenter: { lng: 116.397428, lat: 39.90923 },
            lng: 0,
            lat: 0,
            loaded: false,
            setWholeTime: 0,
            searchOption: {
                city: '全国',
                citylimit: true,
            },
            saitchData: {},
            projectsAddressMarkers: [],
            projectsStatistics: {
                notWork: 0,
                notFinished: 0,
                trans: 0,
            }, // 工程地址统计
            carStatistics: {
                notWork: 0,
                trans: 0,
                onSite: 0,
                back: 0,
            }, // 车辆统计
            windows: {
                position: { lng: 116.397428, lat: 39.90923 },
                visible: false,
                offset: { width: -10, height: -20 },
            },
            switchData: {},
            // 点标记
            markers: [],
            carPosition: {},
            carInfo: {},
            carStatus: {},
            circles: [],
            oldProjects: [],
            oldCars: [],
            stationList: [], // 场站
            selectedSites: {}, // 选择场站
            currentStationId: '', // 当前场站ID
            fenceData: [], // 当天有任务的工地围栏数据
            // 地图对象
            mapObj: {},
            // 工地围栏
            projectEchoPolygon: [],
            // 工地圆圈
            projectCircles: [],
            // 场站围栏
            stationEchoPolygon: [],
            // 场站圆圈
            stationCircles: [],
            // 任务层状态
            visible: true,

            tenantId: '',
        };
    },
    beforeDestroy() {
        // 清除事件总线eventBus， 不手动清除，它是一直会存在的，就会反复进入
        eventBus.$off('Monitoring');
        eventBus.$off('CoordinateMessage');
    },
    watch: {
        carPosition: {
            deep: true,
            immediate: true,
            handler: function (val) {
                this.markers.forEach(item => {
                    if (item.carName === val.car_license) {
                        item.position = { lng: val.longitude, lat: val.latitude };
                        let direction;
                        if (val.direction) {
                            direction = parseInt(Number(val.direction), 0);
                        } else {
                            direction = 0;
                        }
                        const this_car = this.$('.car' + item.plate_small_number);
                        if (this_car.length > 0) {
                            this.$('.car' + item.plate_small_number).find('p').css('transform', 'rotate(' + direction + 'deg)');
                        } else {
                            this.getContentHtml(item);
                        }
                    }
                });
                this.$forceUpdate();
            },
        },
        carStatus: {
            deep: true,
            immediate: true,
            handler: function (val) {
                let is_change = false;
                this.markers.forEach(item => {
                    if (item.carName === val.car_license && item.status !== val.car_status) {
                        let car_type = '';
                        let car_icon = '';
                        item.status = val.car_status;
                        if ([6].indexOf(item.status) > -1) {
                            car_icon = require('../../../assets/images/productionManagement/blue.png');
                            car_type = 'trans';
                        } else if ([7, 73].indexOf(item.status) > -1) {
                            car_icon = require('../../../assets/images/productionManagement/green.png');
                            car_type = 'onSite';
                        } else if ([77, 8].indexOf(item.status) > -1) {
                            car_icon = require('../../../assets/images/productionManagement/yellow.png');
                            car_type = 'back';
                        } else if ([1, 2, 21, 3, 31, 4, 5].indexOf(item.status) > -1) {
                            car_icon = require('../../../assets/images/productionManagement/red.png');
                            car_type = 'notWork';
                        }
                        if (car_type !== '' && item.type !== car_type) {
                            is_change = true;
                            item.icon = car_icon;
                            item.type = car_type;
                            this.$forceUpdate();
                        }
                    }
                });

                if (is_change) {
                    this.oldCars = JSON.parse(JSON.stringify(this.markers));
                    let notWork = 0; let trans = 0; let onSite = 0; let back = 0;
                    this.markers.map(item => {
                        if ([6].indexOf(item.status) > -1) {
                            trans += 1;
                        } else if ([77, 8].indexOf(item.status) > -1) {
                            back += 1;
                        } else if ([7, 73].indexOf(item.status) > -1) {
                            onSite += 1;
                        } else if ([1, 2, 21, 3, 31, 4, 5].indexOf(item.status) > -1) {
                            notWork += 1;
                        }
                    });
                    this.carStatistics.notWork = notWork;
                    this.carStatistics.trans = trans;
                    this.carStatistics.onSite = onSite;
                    this.carStatistics.back = back;
                }
            },
        },
    },
    created() {},
    mounted() {
        this.tenantId = this.$takeTokenParameters('TenantId');
        eventBus.$on('Monitoring', data => {
            if (data.tenant_id === this.tenantId && data.mixstation_code === this.currentStationId) {
                this.carStatus = JSON.parse(data);
            }
        });
        eventBus.$on('CoordinateMessage', data => {
            if (data.tenant_id === this.tenantId && data.mixstation_code === this.currentStationId) {
                this.carPosition = JSON.parse(data);
            }
        });
        const searchBoxWrapper = document.getElementsByClassName('search-box-wrapper')[0];
        const searchInput = searchBoxWrapper.getElementsByTagName('input')[0];
        searchInput.setAttribute('placeholder', '地图位置');
    },
    methods: {
        // 地图加载完毕
        handleReady({ BMap, map }) {
            this.BMap = BMap;
            this.mapObj = window.map = map;
            // 开启鼠标滚动缩放地图
            map.enableScrollWheelZoom(true);
            const routeName = this.$route.name;
            if (routeName === 'logisticsMonitoringStation') {
                // 拉取所有场站
                this.getStationList();
            } else {
                // 拉取用户场站
                this.getStationUser();
            }
        },
        searchPosFn(val) {
            this.searchPos = val;
        },
        // 返回上级菜单
        onClickLeft() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 切换icon
        checkoutIcon() {
            this.iconStatus = !this.iconStatus;
            this.searchInfo = '';
            if (this.iconStatus) {
                setTimeout(() => {
                    const searchBoxWrapper = document.getElementsByClassName('search-box-wrapper')[0];
                    const searchInput = searchBoxWrapper.getElementsByTagName('input')[0];
                    searchInput.setAttribute('placeholder', '地图位置');
                }, 50);
            }
        },
        // 秒转天
        SecondToDate(msd) {
            let time = msd;
            if (msd) {
                if (msd > 3600) {
                    time = '一小时以上';
                } else if (msd <= 3600 && msd >= 60 ) {
                    time = '大约 ' + parseInt(time / 60.0, 0) + '分钟 以后';
                } else {
                    time = '一分钟以内';
                }
            } else {
                msd = '';
            }
            return time;
        },
        // 点标记
        switchWindow(tab, item, position) {
            this.switchData = item;
            this.windows.visible = false;
            this.windows.position = position;
            const plate_number = item.plate_number || item.carName;
            this.getVehicleNo(plate_number, tab);
        },
        // 搜索
        onSearchResult(pois) {
            if (pois.length > 0) {
                this.mapCenter = pois[0];
                this.zoom = 15;
            }
        },
        // 加载地图数据
        reLoadData() {
            this.getProjectStatus();
            this.getLocation();
        },
        // 获取车辆位置配置
        getCarInterval(status) {
            const setStatus = this.carInfo.plate_number ? this.carInfo.plate_number : status;
            this.$axios
                .get(`/interfaceApi/logistics/car_manager/get_car_interval?car_license=${setStatus}`)
                .then(res => {
                    this.setWholeTime = res;
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 拉取车辆位置列表
        getLocation() {
            const carType = 0;
            this.$axios
                // eslint-disable-next-line max-len
                .get(`/interfaceApi/production/vehicleinfo/get_location?stationId=${this.currentStationId}&carType=${carType}&keywords=${this.searchInfo}`)
                .then(res => {
                    const markersArr = [];
                    this.markers = [];
                    this.carStatistics = {
                        all: 0,
                        notWork: 0,
                        trans: 0,
                        back: 0,
                        onSite: 0,
                    };
                    res.forEach((item, index) => {
                        if (item.status !== 9) {
                            let markersObj = {};
                            if (item.longitude && item.latitude) {
                                const parseIcon = this.getIcon(item);
                                // 车辆信息
                                markersObj = {
                                    carName: item.plate_number,
                                    plate_small_number: item.plate_small_number,
                                    position: { lng: item.longitude, lat: item.latitude },
                                    numberOffset: [],
                                    // content: this.getContentHtml(item),
                                    icon: parseIcon.icon,
                                    size: parseIcon.size,
                                    offset: parseIcon.offset,
                                    visible: false,
                                    type: '',
                                    status: item.status,
                                    rotation: item.direction,
                                };
                                if ([6].indexOf(item.status) > -1) {
                                    markersObj.type = 'trans';
                                    this.carStatistics.trans += 1;
                                } else if ([7, 73].indexOf(item.status) > -1) {
                                    markersObj.type = 'onSite';
                                    this.carStatistics.onSite += 1;
                                } else if ([77, 8].indexOf(item.status) > -1) {
                                    markersObj.type = 'back';
                                    this.carStatistics.back += 1;
                                } else if ([1, 2, 21, 3, 31, 4, 5].indexOf(item.status) > -1) {
                                    markersObj.type = 'notWork';
                                    this.carStatistics.notWork += 1;
                                }
                                markersArr.push(markersObj);
                            }
                        }
                    });
                    if (res.length === 1) {
                        this.mapCenter = { lng: res[0].longitude, lat: res[0].latitude };
                        markersArr[0].size = { width: 40, height: 80 };
                        markersArr[0].offset = { width: 14, height: 80 };
                    }
                    this.oldCars = JSON.parse(JSON.stringify(markersArr));
                    this.markers = markersArr;
                    this.$forceUpdate();
                    this.carStatistics.all = markersArr.length;
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 生成车辆icon点标记
        getIcon(item) {
            let icon = '';
            const size = { width: 0, height: 0 };
            const res = {
                icon: '',
                size: size,
                offset: { width: 0, height: 40 },
            };
            if ([6].indexOf(item.status) > -1) { // 运输中
                icon = require('../../../assets/images/productionManagement/blue.png');
                res.size = { width: 22, height: 38 };
            } else if ([7, 73].indexOf(item.status) > -1) {
                icon = require('../../../assets/images/productionManagement/green.png');
                res.size = { width: 22, height: 38 };
            } else if ([77, 8].indexOf(item.status) > -1) { // 返厂中
                icon = require('../../../assets/images/productionManagement/yellow.png');
                res.size = { width: 22, height: 38 };
            } else if ([1, 2, 21, 3, 31, 4, 5].indexOf(item.status) > -1) {
                icon = require('../../../assets/images/productionManagement/red.png');
                res.size = { width: 22, height: 38 };

            }
            res.icon = icon;
            return res;
        },
        // 生成车辆icon点标记
        getContentHtml(item) {
            let direction;
            let Shtml = '';
            let icon = '';
            if (item.direction) {
                direction = parseInt(item.direction, 0);
            } else {
                direction = 0;
            }
            if ([6].indexOf(item.status) > -1) {
                icon = require('../../../assets/images/productionManagement/blue.png');
            } else if ([7, 73].indexOf(item.status) > -1) {
                icon = require('../../../assets/images/productionManagement/green.png');
            } else if ([77, 8].indexOf(item.status) > -1) {
                icon = require('../../../assets/images/productionManagement/yellow.png');
            } else if ([1, 2, 21, 3, 31, 4, 5].indexOf(item.status) > -1) {
                icon = require('../../../assets/images/productionManagement/red.png');
            }
            Shtml += '<div class="car' + item.plate_small_number + '">';
            if (direction === 90 || direction === 270) {
                Shtml += '<p class="amap-marker-icon" style="height:32px; transform:rotate(' + direction + 'deg);">';
            } else {
                Shtml += '<p class="amap-marker-icon" style="transform:rotate(' + direction + 'deg);">';
            }
            Shtml += '<img src=' + icon + '>';
            Shtml += '</p>';
            Shtml += '<p class="amap-marker-label">' + item.plate_small_number + '</p>';
            Shtml += '</div>';
            return Shtml;
        },
        // 获取车辆信息
        getVehicleNo(carName) {
            this.$axios
                .get(`/interfaceApi/production/vehicleinfo/get_vehicle_no?plate_number=${carName}`)
                .then(res => {
                    this.carInfo = res;
                    this.windows.visible = true;
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 获取当天有任务的工地
        getProjectStatus() {
            const currentDate = util.currentTimeFormat('yyyy-MM-dd');
            this.$axios
                .get('/interfaceApi/production/producttask/get_project_status?date=' + currentDate + '&stationCode=' + this.currentStationId)
                .then(res => {
                    if (res.length > 0) {
                        this.addProjectFence(res);
                    }
                })
                .catch(error => {
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 添加所有工地marker和围栏数据
        addProjectFence(res) {
            let all = 0; let notWork = 0; let notFinished = 0; let trans = 0;
            this.fenceData = [];
            this.projectsAddressMarkers = [];
            // 清空工地围栏
            if (this.projectEchoPolygon.length > 0) {
                this.mapObj.removeOverlay(this.projectEchoPolygon);
            }
            this.projectCircles = [];
            // 工地按状态分类
            res.map(item => {
                item.longitude = item.project_longitude;
                item.latitude = item.project_latitude;
                // const obj = new this.BMap.Point(arr.bd_lng, arr.bd_lat);
                if (item.project_longitude && item.project_latitude) {
                    const markersObj = {
                        position: { lng: item.project_longitude, lat: item.project_latitude },
                        icon: require('../../../assets/images/productionManagement/flag_blue.png'),
                        size: { width: 26, height: 24 },
                        visible: false,
                        status: item.status,
                        type: '',
                        project_code: item.project_code,
                        project_name: item.project_name,
                    };
                    if (item.status === 1) {
                        markersObj.icon = require('../../../assets/images/productionManagement/flag_red.png');
                        markersObj.type = 'notWork';
                        item.fenceType = 'notWork';
                    } else if (item.status === 3) {
                        markersObj.icon = require('../../../assets/images/productionManagement/flag_green.png');
                        markersObj.type = 'trans';
                        item.fenceType = 'trans';
                    } else {
                        markersObj.type = 'notFinished';
                        item.fenceType = 'notFinished';
                    }
                    const width = -(item.project_name.length * 11) / 2;
                    markersObj.offset = { width: width, height: 30 };
                    this.projectsAddressMarkers.push(markersObj);
                    item.longitude = item.project_longitude;
                    item.latitude = item.project_latitude;
                    this.fenceData.push(item);
                }
                if (item.status === 1) {
                    notWork += 1;
                } else if (item.status === 3) {
                    trans += 1;
                } else {
                    notFinished += 1;
                }
            });
            this.oldProjects = JSON.parse(JSON.stringify(this.projectsAddressMarkers));
            all = res.length;
            this.projectsStatistics.all = all;
            this.projectsStatistics.notWork = notWork;
            this.projectsStatistics.notFinished = notFinished;
            this.projectsStatistics.trans = trans;
            // 所有工地画围栏
            this.drawStationFence(res, 'project');
        },
        // 拉取用户关联场站
        getStationUser() {
            const Uid = this.$takeTokenParameters('Uid');
            this.$axios
                .get('/interfaceApi/baseinfo/stationmanger/get_station_user?userId=' + Uid)
                .then(res => {
                    if (res.length > 0) {
                        res.forEach(item => {
                            item.text = item.name;
                            item.value = item.station_id;
                        });
                        this.stationList = res;
                        this.currentStationId = res[0].station_id;
                        this.reLoadData();
                        this.mapCenter = { lng: res[0].longitude, lat: res[0].latitude };
                        this.drawStationFence([res[0]], 'station');
                    }
                })
                .catch(error => {
                    this.$message.error(error.TypeError);
                });
        },
        // 拉取用户关联场站
        getStationList() {
            this.$axios
                .get('/interfaceApi/baseinfo/stationmanger/get_station_list')
                .then(res => {
                    if (res.length > 0) {
                        res.forEach(item => {
                            item.text = item.name;
                            item.value = item.station_id;
                        });
                        this.stationList = res;
                        this.currentStationId = res[0].station_id;
                        this.reLoadData();
                        this.mapCenter = { lng: res[0].longitude, lat: res[0].latitude };
                        this.drawStationFence([res[0]], 'station');
                    }
                })
                .catch(error => {
                    this.$message.error(error.TypeError);
                });
        },
        // 顶部场站筛选
        changeStation(data) {
            this.stationList.forEach(item => {
                if (item.value === data) {
                    this.selectedSites = item;
                }
            });
            this.currentStationId = data;
            // this.circles = [];
            this.mapCenter = { lng: this.selectedSites.longitude, lat: this.selectedSites.latitude };
            this.reLoadData();
            // 画当前场站围栏
            if (this.stationEchoPolygon.length > 0) {
                this.mapObj.removeOverlay(this.stationEchoPolygon);
            }
            this.stationCircles = [];
            this.drawStationFence([this.selectedSites], 'station');
        },
        // 画围栏或半径500m 圆圈
        drawStationFence(data, type) {
            if (data) {
                data.map(item => {
                    if (item.fence_point) {
                        const arr = item.fence_point.split('|');
                        const polygonPath = [];
                        arr.map(item => {
                            const lngLat = item.split(',');
                            const obj = new this.BMap.Point(lngLat[0], lngLat[1]);
                            polygonPath.push(obj);
                        });
                        // 创建面覆盖物
                        // eslint-disable-next-line no-undef
                        const echoPolygon = new this.BMap.Polygon(polygonPath, {
                            fillColor: '#F7B500',
                            strokeColor: '#F7B500',
                            fillOpacity: 0.3,
                            strokeWeight: 2,
                        });
                        if (type === 'project') {
                            this.projectEchoPolygon.push(echoPolygon);
                        } else {
                            this.stationEchoPolygon.push(echoPolygon);
                        }
                        this.mapObj.addOverlay(echoPolygon);
                    } else if (item.longitude && item.latitude) {
                        if (type === 'project') {
                            this.projectCircles.push(
                                {
                                    center: { lng: item.longitude, lat: item.latitude },
                                    radius: 500,
                                    strokeColor: '#e87f8d', // 线条颜色
                                    strokeOpacity: 0.8, // 轮廓线透明度
                                    strokeWeight: 2, // 轮廓线宽度
                                    fillColor: '#e87f8d', // 圆形填充颜色
                                    fillOpacity: 0.3, // 圆形填充透明度
                                    strokeStyle: 'dashed', // 轮廓线样式，实线:solid，虚线:dashed
                                },
                            );
                        } else {
                            this.stationCircles.push(
                                {
                                    center: { lng: item.longitude, lat: item.latitude },
                                    radius: 500,
                                    strokeColor: '#e87f8d', // 线条颜色
                                    strokeOpacity: 0.8, // 轮廓线透明度
                                    strokeWeight: 2, // 轮廓线宽度
                                    fillColor: '#e87f8d', // 圆形填充颜色
                                    fillOpacity: 0.3, // 圆形填充透明度
                                    strokeStyle: 'dashed', // 轮廓线样式，实线:solid，虚线:dashed
                                },
                            );
                        }
                    }
                });
            }
        },
        // 点击右侧工地筛选
        handleProjectsClick(num) {
            let Markers = [];
            this.projectsAddressMarkers = this.oldProjects;
            // 清空工地围栏
            if (this.projectEchoPolygon.length > 0) {
                this.mapObj.removeOverlay(this.projectEchoPolygon);
            }
            this.projectCircles = [];
            let fenceData = [];
            switch (num) {
                case 0:
                    this.projectsAddressMarkers.map(item => {
                        if (item.type === 'trans') {
                            Markers.push(item);
                        }
                    });
                    this.fenceData.map(item => {
                        if (item.fenceType === 'trans') {
                            fenceData.push(item);
                        }
                    });
                    break;
                case 1:
                    this.projectsAddressMarkers.map(item => {
                        if (item.type === 'notFinished') {
                            Markers.push(item);
                        }
                    });
                    this.fenceData.map(item => {
                        if (item.fenceType === 'notFinished') {
                            fenceData.push(item);
                        }
                    });
                    break;
                case 2:
                    this.projectsAddressMarkers.map(item => {
                        if (item.type === 'notwork') {
                            Markers.push(item);
                        }
                    });
                    this.fenceData.map(item => {
                        if (item.fenceType === 'notwork') {
                            fenceData.push(item);
                        }
                    });
                    break;
                default:
                    // 所有工地
                    fenceData = this.fenceData;
                    Markers = this.projectsAddressMarkers;
            }
            // 工地围栏
            this.drawStationFence(fenceData, 'project');
            this.projectsAddressMarkers = Markers;
        },
        // 点击右侧车辆筛选
        handleCarClick(num) {
            let data = [];
            this.markers = [];
            switch (num) {
                case 0:
                    this.oldCars.map(item => {
                        if (item.type === 'trans') {
                            data.push(item);
                        }
                    });
                    break;
                case 1:
                    this.oldCars.map(item => {
                        if (item.type === 'back') {
                            data.push(item);
                        }
                    });
                    break;
                case 2:
                    this.oldCars.map(item => {
                        if (item.type === 'onSite') {
                            data.push(item);
                        }
                    });
                    break;
                case 3:
                    this.oldCars.map(item => {
                        if (item.type === 'notWork') {
                            data.push(item);
                        }
                    });
                    break;
                default:
                    data = this.oldCars;
            }
            data.map((item, index) => {
                item.events = {
                    click: () => {
                        this.switchWindow(index, item, item.position);
                    },
                };
            });
            this.markers = data;
        },
        // 打开任务层
        oprnTask() {
            this.visible = !this.visible;
        },
        // 关闭信息窗口
        closeInfoWindow() {
            this.windows.visible = false;
        },
    },
};
</script>

<style lang="stylus">
.logisticsMonitoring
    height 100%
    .van-nav-bar
        z-index 11
        .van-dropdown-menu,
        .van-dropdown-menu__bar
            background none
            .van-dropdown-menu__title
                color #fff
    section
        height calc(100% - 45rpx)
        overflow: hidden;
        .station-list
            margin-bottom .1rem
            ul
                overflow hidden
                li
                    float left
                    cursor pointer
                    &.station-item
                        width: 110rpx
                        height 40rpx
                        text-align center
                        background #ffffff
                        line-height 40rpx
                        margin-right 10rpx
                        border-radius 5rpx
                        position relative
                        .iconfont
                            color: #fff;
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            z-index: 10;
                            line-height: 16rpx
                            display none
                        .trange
                            position absolute
                            width: 0;
                            height: 0;
                            border-bottom: 26rpx solid #d80016;
                            border-left: 26rpx solid transparent;
                            bottom: 0;
                            right: 0;
                            display none
                    &.active
                        border 1px solid #D10401
                        .iconfont
                            display: block
                        .trange
                            display: block
        .map-con
            height calc(100% - 50rpx)
            position relative
            height 100%
            .amap-marker
                transition: 0.1s
            .amap-marker-content
                p
                    text-align center
                .amap-marker-icon
                    img
                        width 21px
                        height 38px
                        vertical-align: top
                .amap-marker-label
                    border 0 none
                    background-color #fff
                    white-space nowrap
                    box-shadow 0 0 5px 0 rgba(0,0,0,.3)
                    border-radius 5px
                    font-size 14px
                    line-height 16px
                    position static
            .baidumap
                height 100%
                position relative
            .anchorBL
                opacity:0;
            .amap-copyright
                opacity:0;
            .amap-info-close
                width 20rpx
                height 20rpx
                font-size 20rpx
                line-height 20rpx
                text-align center
            .search-box
                position absolute !important
                top 20rpx
                left 10rpx
                width calc(100% - 70rpx)
                height 40rpx
                .search-box-wrapper
                    border-radius 4px
                    overflow hidden
                    input
                        font-size 14rpx
                    .search-btn
                        display block
                        text-align center
                        line-height 40rpx
                        width 40rpx
                        height 40rpx
                        font-size 16rpx
                        background #1577d2 !important
                        color #fff
            .search-tips
                width 100%
                max-height 300rpx
                border-radius 0 0 4px 4px
                li
                    box-shadow none
            .search-car-div
                position: absolute;
                width calc(100% - 70rpx)
                top 20rpx
                left 10rpx
                height 40rpx
                z-index 2
                display flex
                align-items center
                box-shadow: 0 2px 2px rgba(0,0,0,.15);
                background #fff
                border-radius 4px
                overflow hidden
                input
                    width calc(100% - 45rpx)
                    height 40rpx
                    flex 1
                    border none
                    font-size 14rpx
                    color #333
                    padding-left 6rpx
                i
                    background #1577D2
                    width 40rpx
                    height 40rpx
                    color #fff
                    text-align center
                    line-height 40rpx
                    font-size 16rpx
            .mapBtn
                position: absolute;
                top: 20rpx
                right: 10rpx
                z-index 2
                background:linear-gradient(90deg,rgba(58,150,254,1),rgba(64,182,255,1));
                border-radius: 4rpx
                color #fff
                width 40rpx
                height 40rpx
                span
                    display block
                    width 100%
                    height 100%
                    font-size 22rpx
                    line-height 40rpx
                    text-align center
            .checkout-icon
                right: 10rpx;
            .task
                position: absolute;
                right: 10rpx
                bottom 10rpx
                z-index 2
                width 60rpx
                height 60rpx
                background url(../../../assets/images/logisticsMonitoring/arrow_back2@2x.png)
                background-size 100% 100%
                &.open
                    background url(../../../assets/images/logisticsMonitoring/arrow_normal2@2x.png)
                    background-size 100% 100%
            .setting-window
                background #fff
                padding 20rpx
                .setting-window-top
                    position relative
                    p
                        color #333333
                        font-size 18rpx
                    span
                        position absolute
                        width: 0;
                        height: 0;
                        border-left: .13rem solid transparent;
                        border-right: .13rem solid transparent;
                        border-bottom: .2rem solid #fff;
                        top -40rpx
                .setting-input
                    width 300rpx
                    height 40rpx
                    border 1px solid #D7D7D7
                    display flex
                    justify-content space-between
                    align-items center
                    margin-top 20rpx
                    border-radius 4px
                    input
                        border none
                        text-align center
                        height 100%
                        flex 2
                    span
                        padding-right 20rpx
                        font-size 16rpx
                .setting-btn
                    margin-top 20rpx
                    text-align center
                    .van-button
                        margin 0 20rpx
                        height 30rpx
                        line-height 30rpx
                        border-radius 4px
            .setting-window-two
                .setting-window-top span
                    position absolute
                    width: 0;
                    height: 0;
                    border-top: 13rpx solid transparent;
                    border-right: 20rpx solid #fff;
                    border-bottom: 13rpx solid transparent;
                    left -50rpx
                    top 0rem
            .antline-btn
                position absolute
                top 40rpx
                left 700rpx
                background:linear-gradient(90deg,rgba(58,150,254,1),rgba(64,182,255,1));
                box-shadow:0px 2px 10px 0px rgba(0, 0, 0, 0.3);
                color #fff
                width 90rpx
                height 40rpx
                border-radius: 4rpx;
                text-align center
                line-height 40rpx
                z-index 10
                font-size 14rpx
                cursor pointer
                .icontiaodu
                    font-size 14rpx
                    margin-right 5rpx
            .info-header
                padding: 0 12rpx
            .info-detailed
                >div
                    padding: 0 12rpx
            .car-info
                background #fff
                width 100%
                .info-header
                    justify-content space-between
                    align-items center
                    font-size 16rpx
                    color #333333
                    height 42rpx
                    border-bottom 1px solid #D7D7D7
                    span
                        float left
                        line-height: 42rpx
                    .iconfont
                        cursor pointer
                    .transportation-status-green
                        background #66AF1C
                    .transportation-status-red
                        background #FA2606
                    .transportation-status-yellow
                        background #FF7E00
                    .transportation-status
                        color #fff
                        font-size 12rpx
                        height 20rpx
                        line-height 20rpx
                        padding: 0 6rpx
                        margin: 11rpx 0
                        border-radius: 3px
                        font-weight 800
                    div:first-child
                        .iconfont
                            font-size 17rpx
                            margin-right 5rpx
                    .trumpet
                        width:auto;
                        height: 22rpx
                        font-size 16rpx
                        color #666666
                        line-height 22rpx
                        padding: 0 6rpx
                        margin: 10rpx
                        background:rgba(19,122,220,0.08);
                        border:1px solid rgba(190,204,223,1);
                .info-detailed
                    >div
                        display flex
                        align-items center
                        font-size 14rpx
                        color #666666
                        height 36rpx
                        border-bottom 1px solid #F0F0F0
                        &:last-child
                            border-bottom none
                        p
                            flex 1
                            white-space nowrap
                            &:nth-of-type(2)
                                margin-left 20rpx
                            .iconfont
                                font-size 14rpx
                                margin-right 5rpx
                                cursor pointer
                            span
                                white-space nowrap
                .icon
                    position: absolute
                    bottom 2px
                    left 50%
                    transform: translateX(-50%)
                    font-size: 24rpx
                    color #fff
</style>
